import React, {useState} from 'react'
import PlusIcon from "../../../../statics/assets/icons/plus.svg"
import CalloutAssignModal from "./CalloutAssignModal"

const CalloutAssign = (props) => {
    const [showModal, toggleModal] = useState(false)

    const _toggleModal = () => {
        toggleModal(!showModal)
    }

    return <>
        <button className="ButtonCustom ButtonDark mr-3" onClick={_toggleModal}><PlusIcon width={12} height={12}/>Gán
            nhóm gọi ra
        </button>
        {showModal && <CalloutAssignModal showModal={showModal} toggleModal={_toggleModal} {...props}/>}
    </>
}

export default CalloutAssign
